module.exports = __webpack_public_path__ + "img/Plastic006_1K_Color.aa176599.jpg";